"use strict";
// import hash from 'object-hash';
// import { ObjectHash } from './object-hash';
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateOsmosysObjectHash = (obj, options) => {
    return JSON.stringify({ obj, options });
};
//# sourceMappingURL=generateOsmosysObjectHash.js.map